var _rect, _ellipse, _ellipse2, _ellipse3, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrayIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 100,
    width: 100,
    viewBox: "0 0 101 100",
    strokeLinejoin: "round",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 100,
    height: 100,
    fill: "none"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 33.1,
    cy: 50,
    rx: 5.9,
    ry: 6.3
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 67.8,
    cy: 50,
    rx: 5.9,
    ry: 6.3
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 50.4,
    cy: 50,
    rx: 5.9,
    ry: 6.3
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.4 24.3c2.4 0 4.8 0 7.2 0 0 0 1.8 0.3 2.1 1.7 0.2 1.2-0.8 2.4-2.1 2.5 -2.8 0-5.7-0.2-8.5 0 0 0 0 2.1 0.2 4.1 0.3 3.2 0.5 6.4 0.1 9.8 -0.8 7-0.1 15-0.1 22 0 1.5 0 3 0 4.5 0 0.8 0 1.6 0 2.4 0.1 0 0.3-0.1 0.4-0.1 2.4-0.4 4.8-0.1 7.2-0.1 0 0 2 0.4 2.1 1.9 0.1 1.3-1.2 2.3-2.7 2.3 -2.4 0-4.8 0-7.3 0.3 -0.9 0.1-2 0.1-2.8-0.5 -0.5-0.3-0.2-0.1-0.5-0.4 0 0-0.6-2-0.7-3.8 -0.1-8.6-0.2-17.1-0.1-25.7 0-3.1 0.7-6.2 0.4-9.3 -0.2-2.3-0.5-4.5-0.5-6.8 0-1.1-0.2-2.1 0.1-3.2 0.2-0.7 0-0.3 0.4-0.7l0.2-0.2c0.4-0.3 0.4-0.3 0.6-0.4 0.5-0.2 1.2-0.2 1.2-0.2 1-0.1 2.1-0.2 3.1-0.2Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M79 24.3c1.5 0 3.3-0.1 4.2 0.7 0.2 0.2 0.1 0 0.3 0.3l0.2 0.3c0.2 0.4 0.1-0.2 0.3 1 0.7 4.3-1 8.8-0.5 13.7 1 10.1 0.3 21 0.2 30.6 0 0.7-0.1 1.8-0.1 1.8 0 0.1 0 0.1 0 0.2 0 0.6-0.1 1.2-0.4 1.7 -0.1 0.2 0 0.1-0.3 0.3 0 0-0.6 0.4-1 0.6 -1.8 0.6-3.6-0.3-5.8-0.2 -1.4 0-2.7 0.1-4.1 0.1 0 0-1.2 0-1.8-0.8 -1-1.3 0-3.4 1.8-3.4 0.1 0 0.3 0 0.4 0 0.2 0 0.3 0 0.5 0 2.2-0.1 4.5-0.2 6.6 0.2 0 0 0.1-3.7 0.1-6.9 0-6.4 0.2-12.9 0.1-19.4 0-2.8-0.6-5.5-0.5-8.4 0.1-2.5 0.6-5 0.6-7.4 0-0.9 0.3-0.7-0.3-0.7 -2.6 0-5.3 0-7.9 0 -1 0-2.6-0.9-2.3-2.5 0.2-0.8 0.9-1.5 1.7-1.7 0.7-0.1 1 0 1.4 0 2.2 0 4.4 0 6.7 0Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrayIcon);
export default __webpack_public_path__ + "static/media/arrayIcon.db9b938255cbf33b091b107dc38d911d.svg";
export { ForwardRef as ReactComponent };